<div class="basicrow m-bott-banner m-bott" *ngIf="this.type=='prepaid'">
  <div class="container-banner">
    <img width="100%" src="../../../assets//images/banner_movil_iptv-landing.jpg">
    <div class="container-btm-img" (click)="this.goToIptv();">
      <img routerLink="/iptv/1" class="btm-img" src="../../../assets//images/boton-banner-iptv.png">
    </div>
    <img width="100%" src="../../../assets/images/banner-prepago.jpg">
  </div>
</div>
<div class="basicrow m-top-banner m-bott-banner" *ngIf="(this.type=='postpaid')  || (this.type=='fixed')">
  <mat-carousel class="carousel-home" timings="2000ms ease-in" [autoplay]="true" color="accent"
    [interval]="this.rotationTime" maxWidth="auto" [loop]="true" [hideArrows]="true" [hideIndicators]="false"
    [useKeyboard]="true" [useMouseWheel]="false">
    <mat-carousel-slide #matCarouselSlide class="carouselBanner" [hideOverlay]="true">
      <div class="container-banner">
        <div class="webW">
          <img width="100%" src="../../../assets/images/banner_iptv.jpg">
          <div class="container-btm-img" (click)="this.goToIptv();">
            <img routerLink="/iptv/1" class="btm-img" src="../../../assets/images/boton-banner-iptv.png">
          </div>
        </div>
        <div class="movilB">
          <img width="100%" src="../../../assets/images/banner_movil_iptv-landing.jpg">
          <div class="container-btm-img" (click)="this.goToIptv();">
            <img routerLink="/iptv/1" class="btm-img" src="../../../assets/images/boton-banner-promocional_movil.png">
          </div>
        </div>
      </div>
    </mat-carousel-slide>
    <mat-carousel-slide #matCarouselSlide class="carouselBanner" [hideOverlay]="true">
      <div class="container-banner">
        <div class="webW">
          <a href="https://www.claroproteccion.pr/" target="_blank" rel="noopener noreferrer">
            <img width="100%"
              src="../../../assets/images/../../../assets/images/banner-proteccion-_miclaro_web-sinboton.jpg">
            <div class="container-btm-img">
              <img class="btm-img" src="../../../assets/images/banner-proteccion-_miclaro_web-boton.png">
            </div>
          </a>
        </div>
        <div class="movilB">
          <a href="https://www.claroproteccion.pr/" target="_blank" rel="noopener noreferrer">
            <img width="100%" src="../../../assets/images/banner-proteccion-_miclaro_movil-375x234-sinboton.jpg">
            <div class="container-btm-img">
              <img class="btm-img" src="../../../assets/images/banner-proteccion-_miclaro_movil-375x234-boton.png">
            </div>
          </a>
        </div>
      </div>
    </mat-carousel-slide>
  </mat-carousel>
</div>
